import '../../modules/mode-components';

import { PdfExportFacade } from '@mode/report-viewer/pdf-export/domain';
import * as angular from 'angular';
import { PdfExportJob } from 'libs/shared/contract-common/src/lib/pdf-export/pdf-export.types';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

const pdfExportDirective = function (pdfExportFacade: PdfExportFacade) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
      reportRun: '<',
    },
    link: function ($scope: angular.IScope, elem) {
      let isPolling = false;
      $scope.$on('$destroy', () => (isPolling = false));

      function pollJob(job: PdfExportJob) {
        combineLatest([job.complete$, job.link$])
          .pipe(takeWhile(() => isPolling))
          .subscribe(([done, link]) => {
            if (done && link) {
              $scope.pdfExportAvailable = done;
              elem.attr('href', link).attr('download', 'true').attr('target', '_self');
              isPolling = false;
            }
          });
      }

      elem.on('click.pdfExport', (event) => {
        if (!$scope.job) {
          isPolling = true;
          const job = pdfExportFacade.exportPdf($scope.reportRun.token, true);
          $scope.job = job;
          pollJob(job);
        } else if (!$scope.pdfExportAvailable) {
          // if a job already is running, then open the dialog
          event.stopPropagation();
          event.preventDefault();
          pdfExportFacade.openPdfExportModal();
        }
      });
    },
  };
};

pdfExportDirective.$inject = ['PdfExportFacade'];

angular.module('mode.components').directive('pdfExport', pdfExportDirective);
